

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { TableApi } from '../api/table.api';
import { switchMap, map } from 'rxjs/operators';
import { TableData, Table } from '../../../interfaces/masters/table';

@Injectable()
export class TableService extends TableData {

  constructor(private api: TableApi) {
    super();
  }
  list(url: string): Observable<Table[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<Table>{
      return this.api.getById(url);
  }

  create(url: string, data:Table): Observable<Table> {
    return this.api.add(url,data);
  }

  update(url: string, data:Table): Observable<Table> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
